<template>
  <div class="border-right">
      <div class="btn-container bg-cx3 p-2 d-flex justify-content-between">
        <button class="btn btn-sm btn-outline-light border-0" @click="newInvoice">
          <i class="far fa-edit"></i> New
        </button>
        <button class="btn btn-sm btn-outline-light border-0" @click="refresh">
          <i class="fa fa-sync-alt"></i>
        </button>
      </div>
      <div class="list-group">
        <template v-for="status in statuses" >
          <router-link :to="'/invoices/' + status.slug" 
            v-if="!status.hide"
            :key="status.id"
            class="list-group-item list-group-item-action d-flex flex-row justify-content-between border-0"
            :class="{ active: status.active }"
          > 
            <span>
              <i class="far fa-folder mr-2" :class="{'fa-folder-open': status.active}"></i>
              {{ status.name }}
            </span>
            <span v-if="status.ct" class="badge badge-warning">{{ status.ct }}</span>
          </router-link>
        </template>
      </div>
  </div>
</template>

<script>

export default {
  name: 'status-menu',

  props: ['statuses'],

  components: {
  },

  methods: {
    refresh() {
      this.$emit('refresh')
    },

    newInvoice() {
      alert('Not yet, but soon.')
    }
  }
}
</script>

<style scoped>
  .badge {
    padding: 5px;
  }
  .list-group {
    height: calc(100vh - 48px);
    background: none;
    opacity: .8;
  }

  .list-group-item {
    color: #efefef;
    background: transparent;
    padding: 0.5rem 1rem;
    border:0;
  }

  .list-group-item-action:hover {
    background-color: rgb(53, 73, 104);
    color: ##fff;
  }

  .list-group-item.active {
    background: rgb(53, 73, 104);
    border: 0;
  }
  .btn-container {
    margin-top: 0px;
    opacity: .8;
    border-bottom:1px solid rgb(53, 73, 104);
  }
</style>